import { render, staticRenderFns } from "./Depoist.vue?vue&type=template&id=718b6966&"
import script from "./Depoist.vue?vue&type=script&lang=js&"
export * from "./Depoist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports